import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseInstallmentOrderReport() {
  const MyAxios = UseCustomAxios();

  const GetInstallmentOrderReport = (year, month, callback) => {
    MyAxios.get(`Admin_InstallmentOrdersReport/${year}/${month}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const GetInstallmentOrderDetail = (
    myPC,
    search,
    year,
    month,
    callback,
    bool
  ) => {
    MyAxios.get(
      `Admin_InstallmentOrdersReport/Details/${year}/${month}?w=${search}`,
      {
        headers: {
          IsPage: bool,
          Conditions: JSON.stringify({ pageCondition: myPC }),
        },
      }
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetYearOverview = (callback) => {
    MyAxios.get(`Admin_InstallmentOrdersReport`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetMonthOverview = (year, callback) => {
    MyAxios.get(`Admin_InstallmentOrdersReport/${year}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    GetInstallmentOrderReport,
    GetInstallmentOrderDetail,
    GetYearOverview,
    GetMonthOverview,
  };
}
